import { includes, reduce, head, get, sortBy, isNil } from './nodash';

export const getCollectionType = (collection) => {
  const { handle } = collection;
  const isPaint =
    includes(handle, 'interior-standard') ||
    includes(handle, 'exterior-standard') ||
    includes(handle, 'interior-semi-gloss') ||
    includes(handle, 'exterior-semi-gloss');
  return isPaint ? 'paint' : 'default';
};

export const sortProductsByColorWheel = (colorWheel, list) => {
  const { Colors } = colorWheel;
  const orderMap = reduce(
    (mem, c) => {
      (c.productIds || []).forEach((id) => (mem[id] = c.order));
      return mem;
    },
    {},
    Colors.filter((c) => !isNil(c.color)).map((c, i) => ({
      productIds: c.color.shopify_product_ids,
      order: i,
    }))
  );

  const sorted = sortBy((x) => {
    return orderMap[get('shopifyId', head(x.products))] || -1;
  }, list);
  return sorted;
};
